// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3fLqO","approved":"Status_approved__1sbJv","rejected":"Status_rejected__bGUNI","expired":"Status_expired__3ovEJ","label":"Status_label__tWcnQ"};